const Finish = (function() {
  let state = {
    lang: null
  }
  return {
    init: () => {
      console.log(window.location.hash)
      state.lang = window.location.hash.split('/')[1];
      console.log(state.lang)
      $('.hu').hide();
      $('.en').hide();
      $(`.${state.lang}`).show();
    }
  }
})()

export default Finish;


// WEBPACK FOOTER //
// ./src/Finish.js